"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_router_dom_1 = require("react-router-dom");
//
// assets
//
const accountCopy_1 = require("../../../copy/accountCopy");
//
// components
//
const AccountNavigation_1 = __importDefault(require("./AccountNavigation"));
const Overview_1 = __importDefault(require("./Overview"));
//
// styles
//
const StyledHeader_1 = require("./StyledHeader");
const StyledContent_1 = require("./StyledContent");
const StyledContainer_1 = require("./StyledContainer");
const react_bootstrap_1 = require("react-bootstrap");
const Developer_1 = __importDefault(require("./Developer"));
const Account = ({ newAccount }) => {
    return (react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
        react_1.default.createElement(StyledContainer_1.StyledContainer, null,
            react_1.default.createElement(StyledHeader_1.StyledHeader, null, accountCopy_1.accountCopy.title),
            react_1.default.createElement(AccountNavigation_1.default, null),
            react_1.default.createElement(StyledContent_1.StyledContent, null,
                react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(react_router_dom_1.Route, { path: '/account/overview' },
                        react_1.default.createElement(Overview_1.default, { newAccount: newAccount })),
                    react_1.default.createElement(react_router_dom_1.Route, { path: '/account/developer' },
                        react_1.default.createElement(Developer_1.default, null)),
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: '/account/overview' }))))));
};
Account.propTypes = {
    newAccount: prop_types_1.default.string
};
exports.default = Account;
